import {
  Card,
  CardActionArea,
  Box,
  Typography,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";

export default function AddUserCard({ onClick }) {
  return (
    <Card
      sx={{
        maxWidth: 420,
        // height: "100%",
        border: "2px dashed",
        borderColor: "divider",
      }}
    >
      <CardActionArea
        onClick={onClick}
        sx={{
          height: "100%",
          minHeight: 150,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          sx={{ color: "text.secondary" }}
        >
          <AddIcon sx={{ fontSize: 48, color: "success.light" }} />
          <Typography variant="subtitle1">
            Add User
          </Typography>
        </Box>
      </CardActionArea>
    </Card>
  );
}